export default __webpack_public_path__ + "static/media/gg.9f9631c6.svg";